export class CategoryList {
    public toggleOtherCategories(clickedButton: HTMLElement): boolean {
        const otherCategoriesWrapper = clickedButton.parentElement.querySelector('.other-categories-list');
        if (otherCategoriesWrapper instanceof HTMLElement) {
            otherCategoriesWrapper.classList.toggle('d-none');
        }

        clickedButton.classList.toggle('arrow-dropdown-toggle-primary');
        clickedButton.classList.toggle('arrow-primary-top');
        clickedButton.classList.toggle('text-primary');
        clickedButton.classList.toggle('arrow-bottom');
        return false;
    }
}

(<any>window).skyComponents = (<any>window).skyComponents || {};
(<any>window).skyComponents.categoryList = new CategoryList();
